<template>
  <div class="home">
    <div v-show="isEmpty" class="empty">
      <div><img src="/common/empty.png" /></div>
      <div class="emptyFonts">暂无内容</div>
    </div>
    <div v-show="!isEmpty">
      <a-tabs tab-position="top" @tabClick="callback" :activeKey="currentKey">
        <a-tab-pane
          v-for="quarter in quarterList"
          :key="quarter.id"
          :tab="`${quarter.year}年${quarterMap[quarter.quarter]}`"
        >
          <div class="description">
            <div v-if="task.description" class="description-content">
              <div>内容说明：</div>
              {{ task.description }}
            </div>
          </div>
          <div class="task-table">
            <a-table
              :columns="taskColumns"
              :dataSource="taskData"
              :pagination="false"
              :rowKey="(record, index) => index"
              :loading="loading"
              style="word-break: break-all"
              :scroll="{ x: 1300 }"
            >
              <template slot="moudleTitle">
                <span>材料模板</span
                ><a-button type="link" @click="downLoadALL">全部下载</a-button>
              </template>
              <template slot="moudleFile" slot-scope="data">
                <span> {{ data.mouldName }} </span
                ><a-button type="link" @click="downLoadFile(data)"
                  >下载</a-button
                >
              </template>
              <span slot="companyFiles" slot-scope="data">
                <div v-if="data.files && data.files.length > 0">
                  <div
                    v-for="(file, index) in data.files"
                    :key="index"
                    class="fileCol"
                  >
                    <div class="fileName">
                      {{ file.fileName }}
                      <a-button
                        type="link"
                        style="color: red"
                        @click="deleteFile(file.fileId)"
                        >删除</a-button
                      >
                    </div>
                    <div class="fileDate">{{ file.createAt }}</div>
                  </div>
                </div>
                <div v-if="data.comments && data.comments.length > 0">
                  <div class="comment">
                    <div class="top">
                      Comments:
                      <a-button size="small" @click="openCommentModal(data.taskId)">回复</a-button>
                    </div>
                    <div
                      v-if="data.comments.length > 3 && data.isSpread === false"
                    >
                      <div
                        v-for="(comment, index) in data.comments.slice(0, 3)"
                        :key="index"
                        :class="{'internal': comment.source === 1}"
                      >
                        <span>{{ "— "+ (comment.source === 1 ? '【回复】' : ' ') + comment.comment }}</span
                        ><span class="comment-time">{{
                          comment.createAt
                        }}</span>
                      </div>
                      <a-button type="link" @click="showAllComments(data)"
                        ><a-icon type="down" />展开</a-button
                      >
                    </div>
                    <div
                      v-if="data.comments.length <= 3 || data.isSpread === true"
                    >
                      <div
                        v-for="(comment, index) in data.comments"
                        :key="index"
                        :class="{'internal': comment.source === 1}"
                      >
                        <span>{{ "— "+ (comment.source === 1 ? '【回复】' : ' ') + comment.comment }}</span
                        ><span class="comment-time">{{
                          comment.createAt
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
              <template slot="action" slot-scope="data">
                <a-button @click="uploadFile(data.taskId)">上传文件</a-button>
              </template>
            </a-table>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <!-- 上传文件 -->
    <a-modal
      title="上传文件"
      :visible="showModal"
      width="500px"
      @cancel="saveFiles"
      v-if="showModal"
      destroyOnClose 
    >
      <a-upload-dragger
        name="file"
        :multiple="true"
        :action="uploadAction"
        :headers="headers"
        @change="handleChange"
        :data="getUploadObj"
        :beforeUpload="sign"
        :remove="removeFile"
        :file-list="fileList"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">
          直接拖拽文件到此处即可上传，或点击
          <a>点击上传</a>
        </p>
        <p class="ant-upload-hint">（单个文件最大500MB）</p>
      </a-upload-dragger>
      <a-button @click="saveFiles" type="primary" slot="footer">确认</a-button>
    </a-modal>
    <!-- 上传文件 end -->
    <!-- 回复 -->
    <a-modal
      title="发布评论"
      :visible="showModalComment"
      width="600px"
      @ok="submitComment"
      @cancel="handleCancel"
      v-if="showModalComment"
    >
      <a-textarea placeholder="请输入要评论的内容" v-model="comment" :rows="4"/>
    </a-modal>
    <!-- 回复 end -->
  </div>
</template>

<script>
import { quarterQuery, taskQuery, deleteCompanyFile, replyAdd } from '@/api/fileCollect';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { downloadFile } from 'assets/js/download';
import { genAuthorization } from 'assets/js/auth';

const quarterMap = {
  1: 'Q1',
  2: 'Q2',
  3: 'Q3',
  4: 'Q4',
  5: '年度',
};

const taskColumns = [
  {
    align: 'center',
    width: '35%',
    scopedSlots: { customRender: 'moudleFile', title: 'moudleTitle' },
  },
  {
    title: '完成截止日',
    align: 'center',
    width: '10%',
    dataIndex: 'deadline',
    customRender: (deadline) => {
      return moment.unix(deadline).format('YYYY-MM-DD');
    },
    customCell: () => {
      return {
        style: {
          'min-width': '135px',
        },
      };
    },
  },
  {
    title: '已上传材料',
    width: '500px',
    scopedSlots: {
      customRender: 'companyFiles',
    },
    customCell: (record, rowIndex) => {
      const obj = {
        attrs: {},
      };
      obj.attrs.colSpan = 2;
      return obj;
    },
  },
  {
    title: '上传时间',
    align: 'center',
    width: '150px',
    customRender: (data, row, index) => {
      const obj = {
        attrs: {},
      };
      obj.attrs.colSpan = 0;
      return obj;
    },
  },
  {
    title: '操作',
    align: 'center',
    //   width: "10%",
    fixed: 'right',
    scopedSlots: {
      customRender: 'action',
    },
  },
];

export default {
  data() {
    return {
      isEmpty: false,
      quarterList: [],
      quarterMap: quarterMap,
      currentKey: '',
      task: [],
      taskData: [],
      taskColumns: taskColumns,
      uploadAction:
        process.env.VUE_APP_BASE_API + '/portfolio/gather/uploadCompanyFile',
      taskSelected: '',
      headers: {},
      mouldList: [],
      loading: false,
      showModal: false,
      showModalComment: false,
      comment: '',
      fileList: [],
    };
  },
  created() {
    this.getQuarterList();
  },
  computed: {
    ...mapGetters(['token']),
  },
  methods: {
    async getQuarterList() {
      try {
        let res = await quarterQuery();
        console.log(res);
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            this.quarterList = res.data;
            console.log(this.quarterList);
            this.currentKey = this.quarterList[0].id;
            this.getTaskList(this.currentKey);
            this.isEmpty = false;
          } else {
            this.isEmpty = true;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    callback(val) {
      this.taskData = [];
      this.currentKey = val;
      this.getTaskList(this.currentKey);
    },
    async getTaskList(key) {
      this.loading = true;
      try {
        const index = this.quarterList.findIndex((item) => item.id === key);
        let year = this.quarterList[index].year;
        let quarter = this.quarterList[index].quarter;
        let res = await taskQuery({ year: year, quarter: quarter });
        this.mouldList = [];
        if (res.code === 200) {
          this.task = res.data;
          let taskData = this.task.detail.list;
          console.log(taskData);
          taskData.forEach((e) => {
            this.mouldList.push({ mouldId: e.fileId, mouldName: e.fileName, mouldUid: e.fileUid });
            if (e.comments.length > 0) {
              e.comments.forEach((comment) => {
                comment['createAt'] = moment
                  .unix(comment.createAt)
                  .format('YYYY-MM-DD HH:mm');
              });
            }
            let files = [];
            if (e.companyFiles && e.companyFiles.length > 0) {
              e.companyFiles.forEach((companyFile, index) => {
                files.push({
                  fileName: companyFile.fileName,
                  fileId: companyFile.fileId,
                  createAt: moment
                    .unix(companyFile.createAt)
                    .format('YYYY-MM-DD HH:mm'),
                });
              });
            }
            this.taskData.push({
              taskId: e.id,
              mouldName: e.fileName,
              mouldId: e.fileId,
              mouldUid: e.fileUid,
              deadline: e.deadline,
              files: files,
              comments: e.comments || '',
              isSpread: false,
            });
          });
          console.log(this.taskData);
          this.loading = false;
        }
      } catch (err) {
        console.log(err);
      }
    },
    uploadFile(taskId) {
      console.log(taskId);
      this.taskSelected = taskId;
      this.showModal = true;
    },
    getUploadObj(file) {
      return {
        taskId: this.taskSelected || '',
      };
    },
    sign(file) {
      this.headers = {
        sign: genAuthorization({
          taskId: this.taskSelected,
        }),
        Authorization: this.token,
      };
    },
    handleChange(info) {
      const status = info.file.status;
      this.fileList = [...info.fileList];
      if (status === 'done') {
        let res = info.file.response;
        if (res.code === 200) {
          this.$message.success('上传成功');
        } else {
          this.$message.error(res.msg);
          this.fileList = this.fileList.filter(_ => _.response.code === 200);
        }
      } else if (status === 'error') {
        this.$message.error('上传失败');
      }
    },
    async downLoadFile(data) {
      try {
        downloadFile(data.mouldId, data.mouldUid, data.mouldName);
      } catch (err) {
        console.log(err);
      }
    },
    downLoadALL() {
      this.mouldList.forEach((e) => {
        this.downLoadFile(e);
      });
    },
    async deleteFile(fileId) {
      try {
        let res = await deleteCompanyFile({ fileId: fileId });
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.taskData = [];
          this.getTaskList(this.currentKey);
        }
      } catch (err) {
        console.log(err);
      }
    },
    showAllComments(data) {
      data.isSpread = true;
    },
    saveFiles() {
      this.showModal = false;
      this.taskData = [];
      this.getTaskList(this.currentKey);
    },
    async submitComment() {
      try {
        let res = await replyAdd({ taskId: this.taskSelected, comment: this.comment });
        if (res.code === 200) {
          this.$message.success('回复成功');
          this.showModalComment = false;
          this.taskData = [];
          this.getTaskList(this.currentKey);
        }
      } catch (err) {
        console.log(err);
      }
    },
    handleCancel() {
      this.showModalComment = false;
    },
    openCommentModal(taskId) {
      this.taskSelected = taskId;
      this.showModalComment = true;
    },
    async removeFile(file) {
      try {
        let res = await deleteCompanyFile({ fileId: file.response.data });
        if (res.code === 200) {
          this.$message.success('删除成功');
        }
      } catch (err) {
        console.log(err);
      }
    }
  },
};
</script>

<style lang="less">
.empty {
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .emptyFonts {
    padding-top: 10px;
    font-size: 18px;
    font-weight: bold;
    color: #c0c0c0;
  }
}
.home {
  padding: 20px 20px 0 20px;
  text-align: left;
  .tab-content {
    padding-top: 30px 0;
  }
  .description {
    padding: 30px 10px;
    .description-content {
      padding: 10px 30px;
      text-align: left;
      border-color: #97cbff;
      border-radius: 10px;
      border: 1px solid #97cbff;
    }
  }
  .task-table {
    padding: 10px 10px;
    .file {
      padding-top: 10px;
    }
    .fileCol {
      display: flex;
      .fileName {
        width: 500px;
        padding: 0 20px;
        word-wrap: break-word;
      }
      .fileDate {
        padding: 5px 0 0 5px;
        width: 120px;
      }
    }
    .comment {
      margin: 20px 0px 10px 0px;
      border-color: #97cbff;
      border-radius: 10px;
      border: 1px solid #1890ff;
      color: #1890ff;
      text-align: left;
      padding: 10px 15px;
      .top {
        display: flex;
        justify-content: space-between;
      }
      .comment-time {
        padding-left: 30px;
      }
      .internal {
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .ant-table-thead > tr > th:nth-child(3) {
      text-align: center;
    }
    // .ant-table-tbody > tr > th:nth-child(2) {
    //   min-width: 200px;
    // }
  }
}
</style>